angular.module("app").constant("casinoPaylines", [{
    key: "1 - 15",
    value: "0"
},{
    key: "16 - 25",
    value: "1"
}, {
    key: "26 - 50",
    value: "2"
}, {
    key: "50 - Infinity",
    value: "3"
},{
    key: "No PayLine",
    value: ""
}
]);